import script from "./ExpoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpoDetail.vue?vue&type=script&setup=true&lang=js"

import "./ExpoDetail.vue?vue&type=style&index=0&id=1c619e70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c619e70"]])

export default __exports__